import { render, staticRenderFns } from "./BwGrid.vue?vue&type=template&id=4fc9c3f2&"
import script from "./BwGrid.vue?vue&type=script&lang=js&"
export * from "./BwGrid.vue?vue&type=script&lang=js&"
import style0 from "./BwGrid.vue?vue&type=style&index=0&id=4fc9c3f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports